import { render } from "./AshesView.vue?vue&type=template&id=ddb56f8a"
import script from "./AshesView.vue?vue&type=script&lang=js"
export * from "./AshesView.vue?vue&type=script&lang=js"

import "./AshesView.vue?vue&type=style&index=0&id=ddb56f8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__